<template>
  <div class="block__tabsSidebarRanking">
      <div class="select__wrapper" v-if="showAllButton">
          <PuSkeleton :loading="true" v-if="types && types.length === 0">

          </PuSkeleton>
        <b-form-select v-else v-model="theType" :options="types" @input="displayToType($event)" class="select"></b-form-select>
      </div>
      <Stack></Stack>
      <div class="select__wrapper">
          <PuSkeleton v-if="datesFormat && datesFormat.length === 0" :loading="true">
          </PuSkeleton>
          <CustomSelect v-else
                  :options="datesFormat"
                  :default='defaultDate'
                  class="select"
                  @input="displayToDate($event)"
          />
      </div>


    <b-list-group>
      <div class="entete">
          <div class="toggle" v-if="showAllButton && currentUserType != 'CONFIG_NATIONAL' && currentUserType != 'CONFIG_AGENT' && currentUserType != 'CONFIG_COLLABORATEUR'">
              <span>Tous</span>
              <ion-toggle
                      @ionChange="fetchAll($event)"
                      mode="ios" >
              </ion-toggle>
          </div>
        <PuSkeleton :loading="isLoading" :count="1" width='140px'>
          <div class="title">{{lists.subtitle}}</div>
        </PuSkeleton>
      </div>
        <div class="select-group" v-if="lists.subtitle === 'Agents'">
            <span v-on:click="changeGroup(1)" :class="selectedGroup === 1 ? 'selected' : ''">G1</span><span v-on:click="changeGroup(2)" :class="selectedGroup === 2 ? 'selected' : ''">G2</span>
            <span v-on:click="changeGroup(3)" :class="selectedGroup === 3 ? 'selected' : ''">G3</span><span v-on:click="changeGroup(4)" :class="selectedGroup === 4 ? 'selected' : ''">G4</span>
            <span v-on:click="changeGroup(5)" :class="selectedGroup === 5 ? 'selected' : ''">G5</span>
        </div>
      <PuSkeleton :loading="isLoading" :count="5" width='100%' v-if="lists.subtitle !== 'Agents'">
        <b-list-group-item v-for="(list,index) in lists.ranking" :key="index" :class="list.active ? !list.id ? 'active-rank noclick' : 'active-rank' : !list.id ? 'noclick' : list.id == actualUserId ? 'active-rank' : ''" v-on:click="changeUser(list.id, list.name)">
            <b-button class="btn btn-listSearch">
                <div class="bt-list left">
                  <div class="target" :class="putTheRightClass(list.rank,list.previousRank)">
                    {{putTheRightClass(list.rank,list.previousRank) != 'equal' ? getTheEvolution(list.rank,list.previousRank): ''}}
                  </div>
                  <span class="icon" :class="{active : list.canWin}" v-if="!list.box">
                    <font-awesome-icon :icon="['fas', 'plane-departure']" />
                  </span>
                  <span class="icon" :class="'active'" v-if="list.box">
                          <font-awesome-icon :icon="['fas', 'gift']" />
                        </span>
                  <div class="ranking">
                      {{list.rank}}
                  </div>
                  <div class="fullname">{{list.name}}</div>
                </div>
                <div class="right">
                  <span class="icon"  :class="{active : list.achievedObjectives}">
                    <font-awesome-icon :icon="['fas', 'bullseye-arrow']" />
                  </span>          
                  {{Math.round(list.points).toLocaleString()}}
                </div>
            </b-button>
        </b-list-group-item>
      </PuSkeleton>
        <PuSkeleton :loading="isLoading" :count="5" width='100%' v-else>
            <b-list-group-item v-for="(list,index) in groupList" :key="index" :class="!list.id ? 'noclick' : list.id == actualUserId ? 'active-rank' : ''" v-on:click="changeUser(list.id, list.name)">
                <b-button class="btn btn-listSearch" :class="!list.id ? 'noclick' : ''">
                    <div class="bt-list left">
                        <div class="target" :class="putTheRightClass(list.rank,list.previousRank)">
                            {{putTheRightClass(list.rank,list.previousRank) != 'equal' ? getTheEvolution(list.rank,list.previousRank) : ''}}
                        </div>
                        <span class="icon" :class="'active'" v-if="(hasOneTravel && list.travel) || (!hasOneTravel && list.canWin)">
                          <font-awesome-icon :icon="['fas', 'plane-departure']" />
                        </span>
                        <span class="icon" :class="'active'" v-if="list.box">
                          <font-awesome-icon :icon="['fas', 'gift']" />
                        </span>
                        <span class="icon" :class="'active'" v-if="!list.achievedobjectives && !list.box && !list.canWin && getChallengeSelected === 'b6d36331-b0c3-11ec-9ce5-de1ca8322020'">
                          <font-awesome-icon :icon="['fas', 'do-not-enter']" />
                        </span>
                      <div class="ranking">
                            {{list.rank}}
                        </div>
                        <div class="fullname">{{list.name}}</div>
                    </div>
                    <div class="right">
                  <span class="icon"  :class="{active : list.achievedObjectives}">
                    <font-awesome-icon :icon="['fas', 'bullseye-arrow']" style="color: #006AA2!important" />
                  </span>
                        {{Math.round(list.points).toLocaleString()}}
                    </div>
                </b-button>
            </b-list-group-item>
        </PuSkeleton>

    </b-list-group>


  </div>
</template>

<script>

import Utils from "../../Utils"
import { mapGetters } from 'vuex'
import CustomSelect from '../select/CustomSelect';
import Stack from '../stack/Stack';
import ApiService from '../../../services/ApiService'
import ApiAuthenticationService from '../../../services/ApiAuthenticationService'
import moment from 'moment'
moment.locale('fr');
//
//
export default {
  name: "TabsSidebarRanking",
  components:{ 
    CustomSelect,
    Stack
  },
    computed: {
      ...mapGetters([
        'getGeneral',
        'getChallengeSelected'
      ])
    },  
  props:{
      showAllButton:{default:false},
      actualUserId:{default:null}
  },
  data(){
    return { 
      isLoading:true,
      content:"",
      types:[],
      groupList:[],
      typesList:[],
      dates:[],
      defaultDate:'',
      datesFormat:[],
      datesLists:[],
      hasOneTravel: false,
      theType: null,
      theDate:'',
      currentUserType:'',
      selectedGroup:1,
        all: false,
      lists:{subtitle:'', ranking:[{},{},{},{}]
      },

    }
  },
  created (){
    this.content = this.getGeneral;
    this.getData().then(() => this.isLoading = false);
    this.currentUserType = ApiAuthenticationService.getCurrentUser().type;
  },

  methods : { 
    putTheRightClass (rank, beforeRank){
      return Utils.getTheClassCompare(rank, beforeRank);
    },
    activeIt(target,item){
      if(item == true){
        return target = !target;
      }
    },
      getTheEvolution(rank, previousRank){
          return Utils.compare(rank,previousRank);
      },
    async displayToType ($e){
      //AS SOON AS A LIST IS SELECTED
      if (!this.theDate) {
        return;
      }
      if($e != this.content.selectChoose){
        this.isLoading = true;
        this.theType = $e;
        await ApiService.getConcoursApi().getClassement(ApiAuthenticationService.getCurrentUser().id,this.getChallengeSelected,this.theDate,this.theType).then((data) => {
            this.lists = data.data;
            if(this.lists.subtitle === 'Agents'){
                this.selectedGroup = 1;
                this.groupList = this.lists.ranking[1];
              this.hasOneTravel = false;
              for (const list of this.groupList) {
                if (list.travel) {
                  this.hasOneTravel = true;
                  break;
                }
              }
            }
        });
        this.isLoading = false;
      }
    }, 
    async displayToDate($e){
      //AS SOON AS A LIST IS SELECTED
      if($e != this.content.selectDateChoose){
          this.theDate = this.dates[this.datesFormat.indexOf($e)];
          this.$emit('newDate', this.dates[this.datesFormat.indexOf($e)]);
        this.isLoading = true;
        await ApiService.getConcoursApi().getClassement(ApiAuthenticationService.getCurrentUser().id,this.getChallengeSelected, this.theDate, this.theType, this.all).then((data) => {
            this.lists = data.data;
            if(this.lists.subtitle === 'Agents'){
                this.selectedGroup = 1;
                this.groupList = this.lists.ranking[1];
              this.hasOneTravel = false;
              for (const list of this.groupList) {
                if (list.travel) {
                  this.hasOneTravel = true;
                  break;
                }
              }
            }
        });
        this.isLoading = false;
      }
    },
      fetchAll (event){
          this.isLoading = true;
          this.all = event.target.checked;
          this.getData().then(() => {
              this.isLoading = false;
          });
      },
      changeUser(userId, userName){
          this.$emit('changeUser', {'id' :userId, 'name' : userName});
      },

    async getData(){
      let promises = [];
        if(this.showAllButton && this.theType == null){
          promises.push(ApiService.getConcoursApi().getResultTypes(this.getChallengeSelected).then((data) => {
            this.types = data.data;
            this.theType = this.types[0].value;
          }));
        }

        promises.push(ApiService.getConcoursApi().getResultDate(this.getChallengeSelected).then((data) => {
          this.dates = data.data;
          this.datesFormat = this.dates.map(item => moment(item).format('DD/MM/YYYY'));
          this.defaultDate = this.datesFormat[0];
        }));

        if (this.theDate) {
          promises.push(ApiService.getConcoursApi().getClassement(ApiAuthenticationService.getCurrentUser().id,this.getChallengeSelected, this.theDate, this.theType, this.all).then((data) => {
            this.lists = data.data;
            if(this.lists.subtitle === 'Agents'){
              this.selectedGroup = 1;
              this.groupList = this.lists.ranking[1];
              this.hasOneTravel = false;
              for (const list of this.groupList) {
                if (list.travel) {
                  this.hasOneTravel = true;
                  break;
                }
              }
            }
            if(this.actualUserId == null && this.lists.ranking && this.lists.ranking.length > 0){
              this.changeUser(this.lists.ranking[0].id, this.lists.ranking[0].name);
            }
          }));
        }

        await Promise.all(promises);
    },
      changeGroup(group){
        this.selectedGroup = group;
        this.groupList = this.lists['ranking'][this.selectedGroup];
        this.hasOneTravel = false;
        for (const list of this.groupList) {
          if (list.travel) {
            this.hasOneTravel = true;
            break;
          }
        }
      },
  },
  watch: {
    // Watch if getChallenged updated so open modify content
    getChallengeSelected(){
        this.isLoading = true;
      ApiService.getConcoursApi().getResultDate(this.getChallengeSelected).then((data) => {
        this.dates = data.data;
        this.datesFormat = this.dates.map(item => moment(item).format('DD/MM/YYYY'));
        this.defaultDate = this.datesFormat[0];
        if (this.dates && this.theDate && !this.dates.includes(this.theDate)) {
          this.theDate = this.dates[0];
          this.$emit('newDate', this.dates[0]);
        }
        this.getData().then(() => this.isLoading = false);
      });

    },
  },  
}
</script>
